import IconCatch from '@/components/icons/icon-catch/icon-catch';
import { MediaBlock } from '@cmpsr/blocks';
import { Box, Text } from '@cmpsr/components';
import React from 'react';

type HeroAccountProps = {
  username?: string;
};

function HeroAccount({ username }: HeroAccountProps) {
  return (
    <Box background="gradient-01" mb={{ base: 'spacer-2', md: 'spacer-4' }}>
      <MediaBlock
        variant="horizontal"
        px={{ base: 'spacer-4', md: 'spacer-8', lg: 'spacer-16', xl: 'spacer-24', xxl: 'spacer-32' }}
        py={{ base: 'spacer-5', md: 'spacer-7', lg: 'spacer-8', xl: 'spacer-9' }}
        alignItems="center"
        maxWidth="1440px"
        marginX="auto"
      >
        <Text
          variant={{ base: 'text-header-XL', md: 'text-header-2XL', lg: 'text-header-2XL' }}
          color="text-light"
          whiteSpace="nowrap"
          overflow="hidden"
          textOverflow="ellipsis"
        >
          {username ? (
            <>
              Hi{' '}
              <Text
                as="span"
                textStyle={{ base: 'text-header-xl-v', md: 'text-header-2xl-v', lg: 'text-header-2xl-v' }}
                color={{ base: 'text-light', md: 'text-light', lg: 'text-light' }}
              >
                {username}!
              </Text>
            </>
          ) : (
            <Text
              as="span"
              textStyle={{ base: 'text-header-xl-v', md: 'text-header-2xl-v', lg: 'text-header-2xl-v' }}
              color={{ base: 'text-light', md: 'text-light', lg: 'text-light' }}
            >
              Welcome!
            </Text>
          )}
        </Text>
      </MediaBlock>
    </Box>
  );
}

export default React.memo(HeroAccount);
